const fonts = {
  fontFamilies: {
    Montserrat: 'Montserrat',
    Inter: 'Inter',
  },
  fontSizes: {
    p12: '12px',
    p14: '14px',
    p16: '16px',
    p18: '18px',
    p20: '20px',
    p22: '22px',
    p24: '24px',
    p32: '32px',
    p40: '40px',
  },
  fontWeights: {
    large: 700,
    medium: 500,
    small: 400,
  },
}

export default fonts
